import { OmniElement, html, css, repeat, nothing } from 'omni-ui';

export class CampaignAudienceSegmentInfo extends OmniElement {
  static get properties() {
    return {
      audience: { type: Object },
      stage: { type: Object },
      groups: { type: Object },
      audienceView: { type: String },
      percentageIndex: { type: Number },
    };
  }

  static get styles() {
    return css`
      :host {
        z-index: 2;
      }
      :host,
      [drag-able] {
        max-width: 50%;
        max-height: 80%;
        --drag-left: 44.64rem;
        --drag-top: 18.423rem;
      }
      omni-tile::part(body-slot) {
        margin: 2.14rem 2rem 2.86rem 2rem;
      }
      omni-tile p {
        font-size: 0.85714rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.21429rem;
        letter-spacing: 0.00429rem;
      }
      omni-tile div.info-container {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 2.14rem;
      }
      omni-tile div.custom-segments:not(:last-child) {
        border-bottom: 0.14rem solid var(--color-border);
      }
      omni-tile .custom-segments {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 0.71rem;
        padding-bottom: 2.14rem;
        gap: 2.14rem;
      }
      omni-tile .segment,
      omni-tile .role-for-comms {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 0.57rem;
        min-width: 10rem;
      }
      omni-tile p.segment-title,
      omni-tile p.role-title {
        font-size: 0.92857rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.28571rem;
        letter-spacing: 0.00271rem;
      }
      omni-tile p.segment-size,
      omni-tile p.role-description {
        font-size: 0.85714rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.14286rem;
        letter-spacing: 0.00229rem;
      }
    `;
  }

  constructor() {
    super();
    this.audience = {};
    this.stage = {};
    this.groups = {};
    this.percentageIndex = 0;
    this.audienceView = '';
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('mousedown', this.#handleDocumentClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('mousedown', this.#handleDocumentClick);
  }

  #handleDocumentClick = event => {
    const popup = this.shadowRoot.querySelector('omni-tile');
    if (event.composedPath().includes(popup)) return;
    this.dispatchNewEvent('close-segment-info');
  };

  render() {
    const groupName =
      this.audience?.stagePercentages?.[this.percentageIndex]?.group;
    return html`
      <omni-style>
        <omni-tile drag-able>
          <omni-toolbar slot="header">
            <h3 slot="start" class="title is-4 has-text-weight-normal">
              ${groupName || `${this.audience?.name} - ${this.stage.name}`}
            </h3>
            <button
              slot="end"
              class="button is-text is-shadowless"
              @click=${() => this.dispatchNewEvent('close-segment-info')}
            >
              <omni-icon
                class="is-size-1"
                icon-id="omni:interactive:close"
              ></omni-icon>
            </button>
          </omni-toolbar>

          <p class="is-uppercase">custom segments</p>

          <div class="info-container">
            <div class="custom-segments">
              ${(groupName && this.groups[groupName]?.customSegments.length) ||
              (!groupName &&
                this.audience?.stagePercentages?.[this.percentageIndex]
                  ?.customSegments?.length)
                ? repeat(
                    groupName
                      ? this.groups[groupName]?.customSegments
                      : this.audience.stagePercentages[this.percentageIndex]
                          .customSegments,
                    (segment, index) => `${segment.title}-${index}`,
                    segment => html`
                      <div class="segment">
                        <p
                          class="segment-title is-clamped clamp-2 is-capitalized"
                        >
                          ${segment.title}
                        </p>
                        <p class="segment-size">
                          Target size:
                          ${Number(
                            segment.details['Target Size'],
                          ).toLocaleString()}
                        </p>
                      </div>
                    `,
                  )
                : "There aren't any custom segments for this audience."}
            </div>
            ${this.audienceView === 'comms'
              ? html`
                  <div class="role-for-comms">
                    <p class="is-uppercase">
                      Role for comms:
                      ${groupName
                        ? this.groups[groupName]?.roleForComms?.role
                        : this.audience?.stagePercentages[this.percentageIndex]
                            .roleForComms?.role}
                    </p>
                    <p class="role-title">
                      ${groupName
                        ? this.groups[groupName]?.roleForComms?.title
                        : this.audience?.stagePercentages[this.percentageIndex]
                            .roleForComms?.title}
                    </p>
                    <p class="role-description">
                      ${groupName
                        ? this.groups[groupName]?.roleForComms?.description
                        : this.audience?.stagePercentages[this.percentageIndex]
                            .roleForComms?.description}
                    </p>
                  </div>
                `
              : nothing}
          </div>
        </omni-tile>
      </omni-style>
    `;
  }
}

OmniElement.register(
  'campaign-audience-segment-info',
  CampaignAudienceSegmentInfo,
);
